import i18n from "@/i18n"
export default{
  list: [
    {
      title: "",
      menu: [],
      isCustom: false,
    },
  ],
  createFields: {
    name: {
      type: "text",
      title: i18n.t("名稱"),
      placeholder: i18n.t("輸入"),
      rules: "required",
      required: true,
    },
    sequence: {
      type: "text",
      title: i18n.t("排序"),
      placeholder: i18n.t("輸入"),
    },
  },
  updateFields: {
    name: {
      type: "text",
      title: i18n.t("名稱"),
      placeholder: i18n.t("輸入"),
      rules: "required",
      required: true,
      getValueKey: "text",
    },
    sequence: {
      type: "text",
      title: i18n.t("排序"),
      placeholder: i18n.t("輸入"),
      getValueKey: "sequence"
    },
  },
}